import { motion } from 'framer-motion';

export function LoadingScreen({ label }: { label: string }) {
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-6">
      <div className="mb-7 select-none">
        <img
          src="/centumth logo black.png"
          alt="top100"
          className="h-16 w-auto mx-auto dark:hidden"
        />
        <img
          src="/centumth logo white.png"
          alt="top100"
          className="h-16 w-auto mx-auto hidden dark:block"
        />
      </div>

      {/* Minimal loading bar */}
      <div className="w-full max-w-xs h-2 rounded-full bg-muted overflow-hidden border border-border/60 relative">
        <motion.div
          className="absolute inset-y-0 w-24 bg-foreground"
          initial={{ x: -96, opacity: 0.2 }}
          animate={{ x: 320, opacity: 0.25 }}
          transition={{ repeat: Infinity, duration: 1.2, ease: 'easeInOut' }}
        />
        <motion.div
          className="absolute inset-y-0 w-14 bg-foreground"
          initial={{ x: -56, opacity: 0.35 }}
          animate={{ x: 320, opacity: 0.4 }}
          transition={{ repeat: Infinity, duration: 1.2, ease: 'easeInOut', delay: 0.08 }}
        />
      </div>

      <div className="mt-5 text-xs uppercase tracking-widest font-bold text-foreground/50 flex items-center justify-center">
        <span className="relative inline-flex items-center">
          {label}
          <motion.div
            aria-hidden
            className="absolute left-full ml-1 flex items-center gap-1"
            initial="start"
            animate="animate"
            variants={{
              start: {},
              animate: { transition: { staggerChildren: 0.18, repeat: Infinity, repeatDelay: 0.2 } },
            }}
          >
            {Array.from({ length: 3 }).map((_, i) => (
              <motion.div
                key={i}
                className="h-1.5 w-1.5 rounded-full bg-foreground block"
                variants={{
                  start: { opacity: 0.2, y: 0 },
                  animate: {
                    opacity: [0.2, 1, 0.2],
                    y: [0, -3, 0],
                    transition: { duration: 0.6, ease: 'easeInOut' },
                  },
                }}
              />
            ))}
          </motion.div>
        </span>
      </div>
    </div>
  );
}


